import { SigninService } from './signin.service';
import { Router } from "@angular/router";
import { ToastMessage } from '../toast-message/toast-message.service';
import { AfterViewInit, Component , NgZone, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';

declare var google: any;

@Component({
  selector: 'signin',
  templateUrl: 'signin.component.html',
  providers: [SigninService, ToastMessage]
})
export class SigninComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private signInService: SigninService,
    private ngZone: NgZone,
    private authService: AuthService,
  ) {
  }
  private tokenClient: any;
  private authCheckPromise: Promise<boolean>;

  ngOnInit(): void {
    this.authCheckPromise = this.authService.isAuthenticated();
    // Shared-domain cookies (CSCC or prior payroll login) → skip Google login.
    this.authCheckPromise.then((authenticated) => {
      if (authenticated) {
        this.router.navigate(['/']);
      }
    });
  }

  ngAfterViewInit(): void {
    // Wait for the same auth check; only init Google when unauthenticated.
    (this.authCheckPromise || this.authService.isAuthenticated()).then((authenticated) => {
      if (authenticated) {
        return;
      }
      this.initializeTokenClient();
      this.initializeGoogleSignIn();
    });
  }

  initializeGoogleSignIn():void {
    if (google && google.accounts && google.accounts.id) {
      google.accounts.id.initialize({
        client_id: environment.googleClientId,
        callback: this.handleCredentialResponse.bind(this),
      });
    }else {
      console.error('Google accounts library is not loaded correctly.');
    }
  }

  handleCredentialResponse(response: any) {
    this.tokenClient.requestAccessToken();
  }

  initializeTokenClient(){
    if (google && google.accounts && google.accounts.oauth2) {
      this.tokenClient = google.accounts.oauth2.initTokenClient({
        client_id: environment.googleClientId,
        scope: 'email',
        callback: (tokenResponse) => {
          const accessToken = tokenResponse.access_token;
          this.handleGoogleSignIn(accessToken);
        }
      }),
      console.log('OAuth Token Client Initialized');
    } else {
      console.error('Google OAuth library is not loaded.');
    }
  }

  onSignInClick() {
    if (google && google.accounts && google.accounts.id) {
      google.accounts.id.prompt();  // Show the Google sign-in popup manually
    } else {
      console.error('Google Identity Services library is not loaded correctly.');
    }
  }

  async handleGoogleSignIn(token: any) {
    const data = { accessToken: token, source: "payroll_dashboard" };
    const tokenResponse = await this.signInService.login(data).toPromise();

    this.authService.establishSession(tokenResponse.token, tokenResponse.permissions);
    this.authService.setUserDetails(tokenResponse);
    this.ngZone.run(() => {
      this.router.navigate(['/']);
    });
  }
}
